(() => {
  if (window.rosariumDubaiMerchandising) return;
  const selector = '[data-rdb-merchandising]';
  const instances = new WeakMap();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const railsIn = (root) => [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];

  const mount = (root) => railsIn(root).forEach((rail) => {
    if (instances.has(rail)) return;
    const abort = new AbortController();
    instances.set(rail, abort);
    rail.addEventListener('focusin', (event) => {
      const card = event.target.closest('li');
      if (!card || card.parentElement !== rail) return;
      requestAnimationFrame(() => {
        if (!card.isConnected || !card.contains(document.activeElement)) return;
        const item = card.getBoundingClientRect();
        const viewport = rail.getBoundingClientRect();
        const style = getComputedStyle(rail);
        const left = viewport.left + (parseFloat(style.paddingLeft) || 0);
        const right = viewport.right - (parseFloat(style.paddingRight) || 0);
        const offset = item.left < left ? item.left - left : item.right > right ? item.right - right : 0;
        if (offset) rail.scrollBy({ left: offset, behavior: 'instant' });
      });
    }, { signal: abort.signal });
    rail.addEventListener('keydown', (event) => {
      if (event.target !== rail || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const rtl = getComputedStyle(rail).direction === 'rtl';
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        const next = event.key === (rtl ? 'ArrowLeft' : 'ArrowRight');
        const controls = rail.closest('[data-rdb-home]').querySelectorAll('[data-rail-target]');
        const button = [...controls].find((control) => control.dataset.railTarget === rail.id &&
          control.dataset.direction === (next ? 'next' : 'previous'));
        if (!button) return;
        event.preventDefault();
        button.click();
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const end = Math.max(0, rail.scrollWidth - rail.clientWidth) * (rtl ? -1 : 1);
        rail.scrollTo({ left: event.key === 'Home' ? 0 : end, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    }, { signal: abort.signal });
  });

  const unmount = (root) => railsIn(root).forEach((rail) => {
    instances.get(rail)?.abort();
    instances.delete(rail);
  });

  window.rosariumDubaiMerchandising = { mount, unmount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
